import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { bindActionCreators } from 'redux';

import Brand from 'models/brand';

import PressHeader from 'components/press/press-header';
import Articles from 'components/press/articles';
import PressReleases from 'components/press/press-releases';
import GetInTouch from 'components/press/get-in-touch';
import ReadMore from 'components/press/read-more';

import sendContactInquiryCreator from 'action-creators/brand/send-contact-inquiry';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  pressArticles: PropTypes.instanceOf(List),
  pressReleases: PropTypes.instanceOf(List),
  sendContactInquiry: PropTypes.func.isRequired,
};

const defaultProps = {
  pressArticles: List(),
  pressReleases: List(),
};

const PressPage = ({ brand, pressArticles, pressReleases, sendContactInquiry }) => (
  <Fragment>
    <PressHeader brand={brand} />
    <Articles articles={pressArticles} />
    <PressReleases releases={pressReleases} />
    <GetInTouch brand={brand} sendContactInquiry={sendContactInquiry} />
    <ReadMore />
  </Fragment>
);

const mapStateToProps = (state) => {
  const {
    brand,
    pressArticles,
    pressReleases,
  } = state.brand;

  return {
    pressArticles,
    pressReleases,
    brand,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    sendContactInquiry: sendContactInquiryCreator,
  }, dispatch)
);

PressPage.propTypes = propTypes;
PressPage.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(PressPage);

